module.exports = "/_next/static/images/CollectDataTabs-1-lg@2x-dfdb99e1b7efcff9010e974b714afc59.png";